import { Redirect, Route, Switch } from "react-router-dom";
import React from "react";
import { MachinePage } from "pages/MachinePage";

export const MachineRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/machine/:machineId" component={MachinePage} />

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect
        to="/pages/machine/:machineId"
        from="/pages/machine/:machineId"
      />
      <Redirect to="/pages" />
    </Switch>
  );
};
